import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ui/ErrorBoundary';
import { logDevConsoleGreeting } from './utils/devConsoleGreeting';
import { applyDemoDocumentTitle } from './utils/demoEmulator';

logDevConsoleGreeting();
applyDemoDocumentTitle();

// Unregister any existing service workers to prevent CORS issues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      // Service worker unregistered - console.log removed for production
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
); 